import { GTM_KEY } from '@/env'
import { useEffect } from 'react'
import TagManager from 'react-gtm-module'

export const GoogleTagManagerProvider = () => {
  useEffect(() => {
    const tagManagerArgs = {
      gtmId: GTM_KEY || ''
    }

    if (tagManagerArgs.gtmId) {
      TagManager.initialize(tagManagerArgs)
    }
  }, [])

  return <></>
}
